import { Validators } from '../../../../../../utils/validators';
import { FormModel } from '../../../../../../components/Form';

export const ParentOrgMediaForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.parentOrg_text_logo,
      value: '',
      type: 'upload',
      placeholder: '',
      field: 'logo',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6 },
      required: true,
      multiline: false,
      accept: 'image/*',
    },
    {
      label: strings.parentOrg_text_tab_logo,
      value: '',
      type: 'upload',
      placeholder: '',
      field: 'favicon',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6 },
      required: true,
      multiline: false,
      accept: 'image/*',
    },
  ];
};
